import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import ProfileVendor from '../profileVendor/ProfileVendor';
import TabDriverVendor from './TabDriverVendor';
import { editDriverDialogData, editSubDriverDialogData } from './ViewDriverVendorData';
import { vehicleInfo as generateVehicleInfo } from './ViewDriverVendorData';
import { amenitiesVehicle as aminitiesVehicleInfo } from './ViewDriverVendorData';
import { getDriver, getMatrixDriver, getMoreDriver, getTicketDriver, patchUpdateDriver } from 'redux/actions/UserDriver';
import { getMatrixVehicle, getMoreVehicle, getVehicle } from 'redux/actions/UserVehicle';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

function ViewDriverVendor() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {state} = useLocation();
  const id = state?.driverId;
  const profileId = state?.id;
  const name = state?.name;
  const cityLocation = state?.cityLocation
  const subVendorName = state?.subVendorName
  const [value, setValue] = useState('matrix');
  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data?.body[0])
  const matrixData = useSelector((state) => state?.userMatrixDriver?.userMatrixDriver?.data)
  const ticketData = useSelector((state) => state?.userTicketDriver?.userTicketDriver?.data)
  const moreDetailsData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data)
  const vehicleInfoData = useSelector((state) => state?.userVehicle?.userVehicle?.data);
  const vehicleMoreData = useSelector((state) => state?.userMoreVehicle?.userMoreVehicle?.data);
  const vehicleMatrixData = useSelector((state) => state?.userMatrixVehicle?.userMatrixVehicle?.data);
  const loaderDriverMatrix = useSelector((state) => state?.userMatrixDriver?.loading)
  const loaderDriverTicket = useSelector((state) => state?.userTicketDriver?.loading)
  const loaderDriverMoreDetails = useSelector((state) => state?.userMoreVehicle?.loading)
  const loaderDriverVehicleData = useSelector((state) => state?.userVehicle?.loading)
  const [page, setPage] = useState(0);
  const [defaultValue, setDefaultValue] = useState({});
  const [iconId, setIconId] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const role = localStorage.getItem('role')
  const tabDetails = {
    matrixData:matrixData,
    ticketData:ticketData,
    moreDetailsData:moreDetailsData,
  }
  const loaderdriver = useSelector((state) => state?.userDriver?.loading)

  const filterData =  {
    driverId: id,
    status:"",
    page:"",
    pageSize:"",
    date:"",
    duration:"",
    type:"driver"
  }
  const vehicleInfotable = generateVehicleInfo(vehicleInfoData); 
  const vehicleInfoaminities = aminitiesVehicleInfo(vehicleInfoData);
  const driverVehicleId = driverData?.Vehicle?.id

  const vehicleData = {
    vehicleId: driverVehicleId,
    type:"driver"
  }

  const vehicleComplianceData = {
    submitterId: driverVehicleId,
    submitterType:"vehicle"
  }
  
  const driverFilterData = {
    submitterId: state?.driverId,
    submitterType:"driverProfile"
  }

  const refreshDriverData = () => {
  dispatch(getDriver(filterData));
  dispatch(getMoreVehicle(driverFilterData));
};

  const vehicleMatrix = {
    vehicleId:driverVehicleId,
  }
  const urlSubVendor = window.location.pathname.includes('subvendor')
  const dialogData = urlSubVendor ? editSubDriverDialogData : editDriverDialogData
  const subVendorBreadcrumbPaths = [
    { name: 'City Manager', url: '/vendor', className:'colorGrey' ,},
    { name: cityLocation, url: '/vendor', className:'colorGrey' ,},
    {name:subVendorName, url: '/vendor',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ];

  const SubVendorDriver = [
    { name: 'Sub-Vendor', url: '/subvendor', className:'colorGrey' ,},
    {name:subVendorName, url: '/subvendor',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ];

  const breadcrumbPaths = role === 'adminCompany'  ? urlSubVendor ? subVendorBreadcrumbPaths : [
    { name: 'City Manager', url: '/vendor', className:'colorGrey' ,},
    {name:cityLocation, url: '/vendor',className:'colorGrey'},
    {name:name, url: '',className:'colorBlue'},
  ] : SubVendorDriver;

  useEffect(() => {
    dispatch(getDriver(filterData));
    dispatch(getMatrixDriver(filterData));
  }, []);
  const onEditProfile = (data, code) => {
    const profileData = {
      driverId:id,
      data:{
        "firstName":data?.vendorName,
        "lastName":"",
        "email":data?.email,
        "countryCode":"+91",
        "mobile":data?.number,
        "companyName":"",
        "location":data?.address,
      }
    }
    dispatch(patchUpdateDriver(profileData));
  }

  const onDeleteProfile = () => {
  const profileData = {
    driverId: id,
    data: {
      status: 'Deleted',
    },
  };
  dispatch(patchUpdateDriver(profileData));
  navigate(-1)
};

  const handleChange = (val) => {
    setValue(val)
    if(val==='ticket'){
      dispatch(getTicketDriver(filterData));
    }else if(val==='moreDetails'){
      // dispatch(getMoreDriver(filterData));
      dispatch(getMoreVehicle(driverFilterData))
    }else if(val==='Vehicle'){
      dispatch(getVehicle(vehicleData));
      dispatch(getMoreVehicle(vehicleComplianceData));
      dispatch(getMatrixVehicle(vehicleMatrix));
    }else{
      dispatch(getMatrixDriver(filterData));
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const onClickMoreIcon = (data, iconType) => {
   
    const value = data;
    // setDefaultValue(value);
    // setIconId(data.id);
    if (iconType === 'Delete') {

    } else if (iconType === 'Edit') {
      // setIconType(iconType);
      // setOpen(true);
    }
  };

  const onClickTableVendor = (val) => {
    const url = window.location.pathname.split('/')[2];
    if (url === 'subvendor') {
      if (value === 'Vehicle') {
        navigate(
          '/vendor/subvendor/driver/vehicle', {state:{vehicleId:val?.id, status:val?.status, name:val?.carModel}}
        );
      }
    }else{
      if (value === 'Vehicle') {
        navigate(
          '/vendor/driver/vehicle', {state:{vehicleId:val?.id, status:val?.status, name:val?.carModel}}
        );
      }
    }
  };
//for subheader actions
const onClickStatusIcon = (data) => {
  setDefaultValue(value);
  setIconId(data.id);

  if (data === 'Delete') {
  }
  else if (data === 'Deactivate') {
    const profileData = {
      driverId: id,
      data: {
        status: 'InActive',
      },
    };
    dispatch(patchUpdateDriver(profileData));
  } else if (data === 'Activate') {
    const profileData = {
      driverId: id,
      data: {
        status: 'Active',
      },
    };
    dispatch(patchUpdateDriver(profileData));
  }
  else if (data === 'Block') {
    const profileData = {
      driverId: id,
      data: {
        status: 'Blocked',
      },
    };
    dispatch(patchUpdateDriver(profileData));
  }
  else if (data === 'Unblock') {
    const profileData = {
      driverId: id,
      data: {
        status: 'Active',
      },
    };
    dispatch(patchUpdateDriver(profileData));
  }
};

//roles and permissions 
const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
const subVendorRoleEnum = roleAndPermissionEnum.subvendor
const cityManagerRoleEnum = roleAndPermissionEnum.citymanager
const driverRoleEnum = roleAndPermissionEnum.driver

const accessCityManagerForAdd = handlePermissions(roleAndPermissions, cityManagerRoleEnum.moduleKey, {defaultAllAccess: cityManagerRoleEnum.all, customAccess: cityManagerRoleEnum.add});

const accessForAdd = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {defaultAllAccess: subVendorRoleEnum.all, customAccess: subVendorRoleEnum.add});

const accessForDriverAll = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {defaultAllAccess: driverRoleEnum.all, customAccess: driverRoleEnum.add});

const editAccess = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.edit});

const accessForSubVendorDriverActivate = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.activateDriver});

const accessForSubVendorDriverBlock = handlePermissions(roleAndPermissions, subVendorRoleEnum.moduleKey, {customAccess: subVendorRoleEnum.blockDriver});

const accessForDriverBlock = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.driverBlock});

const accessForDriverActivate = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.driverActivate});

const editButton = (accessCityManagerForAdd ||accessForAdd || accessForDriverAll|| editAccess)

const statusChange = (accessCityManagerForAdd ||accessForAdd || accessForDriverAll||accessForDriverBlock || accessForDriverActivate||accessForSubVendorDriverActivate|| accessForSubVendorDriverBlock )

  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      <ProfileVendor onSubmittBtn={onEditProfile} details={driverData} type={'Driver'} editData={dialogData(driverData)} onClickStatusIcon={onClickStatusIcon} loader={loaderdriver} editButton={!editButton}
        statusChange={statusChange} onDelete={onDeleteProfile}/>
      <TabDriverVendor 
        details={driverData} 
        handleChange={handleChange} 
        value ={value} 
        tabDetails={tabDetails} 
        handleChangePage={handleChangePage} 
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        onClickTableVendor={onClickTableVendor}
        onClickMoreIcon={onClickMoreIcon}
        vehicleInfo={vehicleInfotable} 
        amenitiesVehicle={vehicleInfoaminities}
        driverVehicleId={driverVehicleId}
        vehicleMatrixData={vehicleMatrixData}
        vehicleMoreData={vehicleMoreData}
        loaderDriverMatrix={loaderDriverMatrix}
        loaderDriverTicket={loaderDriverTicket}
        loaderDriverMoreDetails={loaderDriverMoreDetails}
        loaderDriverVehicleData={loaderDriverVehicleData}
        editButton={editButton}
        refreshDriverData={refreshDriverData}
      />
    </div>
  );
}

export default ViewDriverVendor;
